// W2Cook Billing Dashboard — Auth hook

import { useState, useEffect } from "react";
import { onAuthStateChanged, isConfigured, type User } from "./firebase";

export type AuthState = "loading" | "signed-in" | "signed-out" | "misconfigured";

export function useAuth() {
  const [user,      setUser     ] = useState<User | null>(null);
  const [authState, setAuthState] = useState<AuthState>(
    isConfigured ? "loading" : "misconfigured"
  );

  useEffect(() => {
    if (!isConfigured) return;
    const unsubscribe = onAuthStateChanged((u) => {
      setUser(u);
      setAuthState(u ? "signed-in" : "signed-out");
    });
    return unsubscribe;
  }, []);

  return { user, authState };
}
